/* 区分是获取品牌还是条件的汽车列表 */

import React, { useEffect, useReducer, createContext } from 'react'

interface IProps {
  children: React.ReactChild[]
  initProps: ISelectedOptions
}
interface IOption {
  param: number | string
  text: string
}
interface ISetOptionAction {
  type: 'setOption'
  payload: {
    key: string
  } & IOption
}

interface ISetSingleOptionAction {
  type: 'setSingleOption'
  payload: {
    key: string
  } & IOption
}
interface IRemoveOptionAction {
  type: 'removeOption'
  payload: {
    key: string
    param: string | number
  }
}
interface IClearOptionAction {
  type: 'clearOptions'
}
interface IResetOptionsAction {
  type: 'resetOptions'
  payload: ISelectedOptions
}
type IAction =
  | ISetOptionAction
  | ISetSingleOptionAction
  | IRemoveOptionAction
  | IClearOptionAction
  | IResetOptionsAction
// 已选中的条件
// interface ISelectedOptions {
//   [key: string]: Partial<IOption>
// }
interface ISelectedOptions {
  [key: string]: IOption[]
}
// const state = {
//   brand: {
//     param: 2,
//     text: '宝马'
//   }
// }
interface IContext {
  state: ISelectedOptions
  dispatch(param: ISetOptionAction): void
  dispatch(param: ISetSingleOptionAction): void
  dispatch(param: IRemoveOptionAction): void
  dispatch(param: IClearOptionAction): void
  dispatch(param: IResetOptionsAction): void
}

const initOptions = {}

function reducer(state: ISelectedOptions, action: IAction) {
  switch (action.type) {
  case 'setOption': {
    const options = state[action.payload.key] || []
    return {
      ...state,
      [action.payload.key]: options.concat([
        {
          param: action.payload.param,
          text: action.payload.text,
        },
      ]),
    }
  }
  case 'setSingleOption': {
    return {
      ...state,
      [action.payload.key]: [
        {
          param: action.payload.param,
          text: action.payload.text,
        },
      ],
    }
  }
  case 'removeOption': {
    const options = state[action.payload.key] || []
    return {
      ...state,
      [action.payload.key]: options.filter(
        option => option.param !== action.payload.param
      ),
    }
  }
  case 'clearOptions':
    return initOptions
  case 'resetOptions':
    return {
      ...action.payload,
    }
  default:
    return initOptions
  }
}
const ContextStore = createContext<IContext>({
  state: initOptions,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => {},
})

const ContextProvider = (props: IProps) => {
  const { children, initProps } = props
  const [state, dispatch] = useReducer(reducer, initProps || initOptions)
  // if (typeof window !== 'undefined') {
  //   window.state = state
  // }
  useEffect(() => {
    dispatch({
      type: 'resetOptions',
      payload: initProps,
    })
  }, [initProps])
  return (
    <ContextStore.Provider value={{ state, dispatch }}>
      {children}
    </ContextStore.Provider>
  )
}

export { ContextStore, ContextProvider }
